import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import OTPVerification from "@/pages/OTPVerification";
import Dashboard from "@/pages/Dashboard";
import Quiz from "@/pages/Quiz";
import Results from "@/pages/Results";
import AdminResults from "@/pages/AdminResults";
import StudentReport from "@/pages/StudentReport";
import AdminStudents from "@/pages/AdminStudents";
import AdminConfig from "@/pages/AdminConfig";
import { Toaster } from "@/components/ui/sonner";

const getAuthState = () => {
  const email = localStorage.getItem("userEmail");
  const role = localStorage.getItem("userRole");
  const verified = localStorage.getItem("userVerified") === "true";
  return { email, role, verified };
};

const RequireAuth = ({ children }) => {
  const { email, verified } = getAuthState();
  if (!email) return <Navigate to="/login" replace />;
  if (!verified) return <Navigate to="/verify-otp" replace />;
  return children;
};

const RequireAdmin = ({ children }) => {
  const { email, role } = getAuthState();
  if (!email) return <Navigate to="/login" replace />;
  if (role !== "admin") return <Navigate to="/dashboard" replace />;
  return children;
};

const RequireOtp = ({ children }) => {
  const { email, verified } = getAuthState();
  if (!email) return <Navigate to="/login" replace />;
  if (verified) return <Navigate to="/dashboard" replace />;
  return children;
};

function App() {
  const TitleManager = () => {
    const location = useLocation();
    useEffect(() => {
      const map = {
        "/login": "Login",
        "/register": "Register",
        "/verify-otp": "Verify OTP",
        "/dashboard": "Dashboard",
        "/quiz": "Assessment",
        "/results": "Results",
        "/admin-results": "Assessee Reports",
        "/admin-students": "Assessees",
        "/admin-student-report": "Assessee Report",
        "/admin-config": "Configuration",
      };
      const suffix = map[location.pathname];
      document.title = suffix ? `CareerNav | ${suffix}` : "CareerNav";
    }, [location.pathname]);
    return null;
  };

  return (
    <div className="App">
      <BrowserRouter>
        <TitleManager />
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route
            path="/verify-otp"
            element={
              <RequireOtp>
                <OTPVerification />
              </RequireOtp>
            }
          />
          <Route
            path="/dashboard"
            element={
              <RequireAuth>
                <Dashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/quiz"
            element={
              <RequireAuth>
                <Quiz />
              </RequireAuth>
            }
          />
          <Route
            path="/results"
            element={
              <RequireAuth>
                <Results />
              </RequireAuth>
            }
          />
          <Route
            path="/admin-results"
            element={
              <RequireAdmin>
                <AdminResults />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin-students"
            element={
              <RequireAdmin>
                <AdminStudents />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin-student-report"
            element={
              <RequireAdmin>
                <StudentReport />
              </RequireAdmin>
            }
          />
          <Route
            path="/admin-config"
            element={
              <RequireAdmin>
                <AdminConfig />
              </RequireAdmin>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
